import { render } from "./newsTypeManage.vue?vue&type=template&id=b392abea"
import script from "./newsTypeManage.vue?vue&type=script&lang=js"
export * from "./newsTypeManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__